import Head from 'next/head';
import { useRouter } from 'next/router';

import { useAppSelector } from 'shared/lib/redux';

import { metadataSelector, formatSeoText } from 'entities/metadata';
import { baseUrl, baseMplUrl } from 'entities/metadata/model/Seo.constants';

type Props = {
  isMarketplace: boolean;
  metaTags?: Array<{
    name: string;
    value: string;
  }>;
};

export function Seo({ isMarketplace, metaTags }: Props) {
  const { pathname } = useRouter();
  const metadata = useAppSelector(metadataSelector);
  const correctUrl = isMarketplace ? baseMplUrl : baseUrl;

  if (!metadata || !(metadata.title && metadata.description)) {
    return (
      <Head>
        <link
          rel="canonical"
          href={`${correctUrl}/kredity/`}
        />
      </Head>
    );
  }

  return (
    <Head>
      <title>{formatSeoText(metadata.title)}</title>
      {metaTags?.map(({ name, value }) => (
        <meta
          key={name}
          name={name}
          content={value}
        />
      ))}
      <meta
        name="description"
        content={metadata.description}
      />
      <link
        rel="canonical"
        href={metadata?.canonical || correctUrl + pathname}
      />
      <meta
        property="og:type"
        content="website"
      />
      <meta
        property="og:description"
        content={metadata.ogDescription}
      />
      <meta
        property="og:title"
        content={metadata.ogTitle}
      />
      <meta
        property="og:image"
        content="https://f.sravni.ru/f/_/logo_200x200.jpg"
      />
      <meta
        property="og:image:width"
        content="200"
      />
      <meta
        property="og:image:height"
        content="200"
      />
      {metadata.schema ? (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(metadata.schema) }}
        />
      ) : null}
    </Head>
  );
}
